import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { OptionCards } from './OptionCards';
import { formatValue } from './bookingUtils';

const INPUT_TYPES = { email: 'email', phone: 'tel', number: 'number', date: 'date' };

export const FieldInput = ({ field, value, onChange, disabled = false, testId, className = '' }) => {
  const options = field.options || [];
  const inputClass = `h-11 bg-white border-slate-300 focus-visible:ring-[#D4AF37] ${className}`;

  switch (field.type) {
    case 'textarea':
      return (
        <Textarea value={value ?? ''} onChange={(e) => onChange(e.target.value)} placeholder={field.placeholder}
          disabled={disabled} rows={4} className={`bg-white border-slate-300 focus-visible:ring-[#D4AF37] ${className}`} data-testid={testId} />
      );
    case 'dropdown':
      return (
        <Select value={value || ''} onValueChange={onChange} disabled={disabled}>
          <SelectTrigger className={inputClass} data-testid={testId}>
            <SelectValue placeholder={field.placeholder || 'Select an option'} />
          </SelectTrigger>
          <SelectContent>
            {options.map((opt, i) => (
              <SelectItem key={`${opt}-${i}`} value={opt} data-testid={`${testId}-option-${i}`}>{opt}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      );
    case 'radio':
      return <OptionCards options={options} value={value} onChange={onChange} disabled={disabled} testIdPrefix={testId} />;
    case 'checkbox':
      if (options.length > 0) {
        return <OptionCards options={options} value={value} onChange={onChange} multiple disabled={disabled} testIdPrefix={testId} />;
      }
      return (
        <label className={`flex items-center gap-3 p-4 rounded-xl border-2 bg-white ${value ? 'border-[#D4AF37] bg-[#FDFBF7]' : 'border-slate-200'} ${disabled ? 'opacity-80' : 'cursor-pointer hover:border-slate-300'}`}>
          <input type="checkbox" checked={!!value} disabled={disabled} onChange={(e) => onChange(e.target.checked)}
            className="h-5 w-5 rounded border-slate-300 accent-[#D4AF37]" data-testid={testId} />
          <span className="text-sm font-medium text-slate-900">{field.placeholder || 'Yes'}</span>
        </label>
      );
    default:
      return (
        <Input type={INPUT_TYPES[field.type] || 'text'} value={value ?? ''} onChange={(e) => onChange(e.target.value)}
          placeholder={field.placeholder} disabled={disabled} className={inputClass} data-testid={testId}
          min={field.validation?.min} max={field.validation?.max} />
      );
  }
};

export const ReadOnlyValue = ({ value, placeholder = 'Client will fill', testId }) => {
  const text = formatValue(value);
  return (
    <div data-testid={testId} className={`min-h-[44px] rounded-lg border px-3.5 py-2.5 text-sm whitespace-pre-wrap ${
      text ? 'bg-slate-50/80 border-slate-200 text-slate-900' : 'bg-white border-dashed border-slate-300 text-slate-400 italic'
    }`}>
      {text || placeholder}
    </div>
  );
};
